export default {
  decimalPlaces: 2,
  decimalPoint: ',',
  thousandSeparator: '.',
  thousandPlaces: 3,
  currencySymbol: 'R$',
  currencyPosition: 'left',
};
